import HelpTooltip from '@/app/common/components/HelpTooltip';
import { crawlerAssetSetting } from '@/app/Crawl/config/modalSettingsConfig';
import { Col, Form, Row, Tab } from 'react-bootstrap';
import { crawlTooltip } from '@/app/Crawl/tooltip/crawlTooltips';

type SetFieldValue = (
  field: string,
  value: unknown,
  shouldValidate?: boolean
) => Promise<unknown>;

interface AssetsProps {
  values: Record<string, unknown>;
  setFieldValue: SetFieldValue;
}

const isEnabled = (value: unknown): boolean =>
  value === true ||
  value === 'true' ||
  value === 1 ||
  value === '1';

const Assets = ({ values, setFieldValue }: AssetsProps) => {
  return (
    <Tab.Pane className="my-3" eventKey="crawlerAssets">
      <div dir="rtl" className="text-start">
        <Row className="g-3">
          {crawlerAssetSetting.map(item => {
            const enabled = isEnabled(values[item.name]);

            return (
              <Col key={item.name} xs={12} md={6}>
                <div className="crawl-settings-box border rounded-2 p-3 h-100">
                  <div className="d-flex align-items-center justify-content-between gap-3 py-1">
                    <Form.Label htmlFor={item.name} className="mb-0">
                      <span className="d-inline-flex align-items-center">
                        {item.text}
                        <HelpTooltip
                          html={
                            crawlTooltip.crawlSettings.crawlerSettings[
                              item.name
                            ]
                          }
                        />
                      </span>
                    </Form.Label>
                    <div className="d-flex align-items-center gap-2 flex-shrink-0">
                      <span className="fs--1 text-700">
                        {enabled ? 'بله' : 'خیر'}
                      </span>
                      <Form.Check
                        type="switch"
                        id={item.name}
                        name={item.name}
                        checked={enabled}
                        onChange={event =>
                          void setFieldValue(item.name, event.target.checked)
                        }
                        aria-label={item.text}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </Tab.Pane>
  );
};

export default Assets;
